import { css } from '@emotion/react';
import { Box } from '@mui/material';
import { useAtomValue } from 'jotai';
import { clientConfigAtom } from '../../../services/state/AppConfigStateJ';
import { ConfigRowFieldWrapperClass } from '../Common/ConfigItemRow';
import { GenericConfigPage } from '../Common/GenericConfigPage';
import { getClientConfigFields } from './ClientConfigFields';

const ClientConfigRowStyles = css`
  & .${ConfigRowFieldWrapperClass} {
    display: grid;
    grid-template-columns: 20rem repeat(auto-fit, 8rem);
  }
`;

export function ConfigClient() {
  const clientConfig = useAtomValue(clientConfigAtom) ?? [];

  return (
    <Box css={ClientConfigRowStyles} width={'100%'}>
      <GenericConfigPage
        baseTitle={'Application Setting'}
        data={clientConfig}
        fields={[]}
        formFields={getClientConfigFields()}
        pageTitle={'Application Settings'}
        queryURL={'/configuration/client'}
        showCreateButton={false}
      />
    </Box>
  );
}
